import { render, staticRenderFns } from "./SpecialPagination.vue?vue&type=template&id=17b8d6a9&lang=pug"
import script from "./SpecialPagination.vue?vue&type=script&lang=js"
export * from "./SpecialPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports